module.exports = __webpack_public_path__ + "img/userB14.c813a910.jpg";